<template>
  <ValidationObserver ref="observer">
    <template #default="{ handleSubmit, invalid }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <BaseLayoutSpaced loose>
          <BaseLayoutSpaced relaxed>
            <ValidationProvider
              ref="period"
              vid="period"
              rules="required|max:1"
              name="period"
              tag="div"
              class="w-32"
            >
              <template #default="{ errors, failed }">
                <BaseFormGroup>
                  <BaseFormLabel for="period"> Period * </BaseFormLabel>
                  <BaseFormInput
                    id="period"
                    v-model="data.period"
                    type="number"
                    :disabled="disabled"
                  />
                  <BaseFormInlineMessage v-if="failed" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </BaseLayoutSpaced>
          <div>
            <BaseButton type="submit" primary :disabled="disabled || invalid"> Submit </BaseButton>

            <BaseButton type="button" ghost :disabled="disabled" class="ml-2" @click="onCancel">
              Cancel
            </BaseButton>
          </div>
        </BaseLayoutSpaced>
      </form>
    </template>
  </ValidationObserver>
</template>

<script>
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  mixins: [veeValidateErrorsMixin],
  props: {
    defaultData: {
      type: Object,
      required: true,
    },
    serverErrors: {
      type: Object,
      default: () => ({}),
    },
    disabled: Boolean,
  },

  data() {
    return {
      data: {
        period: 1,
        ...this.defaultData,
      },
    };
  },

  computed: {
    exists() {
      return this.defaultData.uuid !== undefined && this.defaultData.uuid !== null;
    },
  },

  watch: {
    serverErrors: {
      deep: true,
      handler: 'applyServerErrors',
    },
  },

  methods: {
    onSubmit() {
      this.$emit('account-subscription-order-form:submit', this.data);
    },

    onCancel() {
      if (this.disabled) return;

      this.$emit('account-subscription-order-form:cancel');
    },

    applyServerErrors(errors) {
      this.observer = this.$refs.observer;
      this.addServerErrors(errors);
    },
  },
};
</script>
